/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Payment_Cod_Text1Inputs */

const vi_sitesettings_checkout_payment_cod_text1 = /** @type {(inputs: Sitesettings_Checkout_Payment_Cod_Text1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả cách trả tiền khi nhận (COD)`)
};

/**

* @param {Sitesettings_Checkout_Payment_Cod_Text1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_payment_cod_text1 = /** @type {((inputs?: Sitesettings_Checkout_Payment_Cod_Text1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Payment_Cod_Text1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_payment_cod_text1(inputs)
});
export { sitesettings_checkout_payment_cod_text1 as "siteSettings_checkout_payment_cod_text" }